import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AgentProvider } from './contexts/AgentContext';
import { Layout } from './components/Layout';
// Import pages
import { AIMapPage } from './pages/AIMapPage';
import { GovernancePage } from './pages/GovernancePage';
import { PolicyPage } from './pages/PolicyPage';
import { AuditTrailPage } from './pages/AuditTrailPage';
import { AIActPage } from './pages/AIActPage';
import { GDPRPage } from './pages/GDPRPage';
import { ImpostazioniPage } from './pages/ImpostazioniPage';
import { ServizioDetailPage } from './pages/ServizioDetailPage';
import { CostManagementPage } from './pages/CostManagementPage';
import { CostManagementDetailPage } from './pages/CostManagementDetailPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AgentProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
            {/* Redirect root to costs (Overview) */}
            <Route index element={<Navigate to="/costs" replace data-id="element-6" />} data-id="element-5" />
            {/* Main Routes */}
            <Route path="canvas" element={<AIMapPage data-id="element-8" />} data-id="element-7" />
            <Route path="servizio/:agentId" element={<ServizioDetailPage data-id="element-10" />} data-id="element-9" />
            <Route path="costs" element={<CostManagementPage data-id="element-12" />} data-id="element-11" />
            <Route path="cost-management" element={<CostManagementDetailPage data-id="element-14" />} data-id="element-13" />

            {/* Compliance Routes with Submenu */}
            <Route path="compliance" data-id="element-15">
              <Route index element={<Navigate to="/compliance/ai-act" replace data-id="element-17" />} data-id="element-16" />
              <Route path="ai-act" element={<AIActPage data-id="element-19" />} data-id="element-18" />
              <Route path="gdpr" element={<GDPRPage data-id="element-21" />} data-id="element-20" />
              <Route path="audit" element={<AuditTrailPage hideHeader={false} data-id="element-23" />} data-id="element-22" />
            </Route>

            <Route path="impostazioni" element={<ImpostazioniPage data-id="element-25" />} data-id="element-24" />
            {/* Catch all - redirect to costs (Overview) */}
            <Route path="*" element={<Navigate to="/costs" replace data-id="element-27" />} data-id="element-26" />
          </Route>
        </Routes>
      </AgentProvider>
    </BrowserRouter>;
}